import './App.css';
import classes from './App.module.css';
import { useState, useEffect, useRef, useContext } from 'react';
import ReactGA from 'react-ga4';
import ErrorMessage from './components/ErrorMessage/ErrorMessage';
import Offers from './components/Offers/Offers';
import CountrySelector from './components/CountrySelector/CountrySelector';
import OfferProvider from './store/OfferProvider';
import CurrencyProvider from './store/CurrencyProvider';
import DataSelector from './components/DataSelector/DataSelector';
import DurationSelector from './components/DurationSelector/DurationSelector';
import { I18nextProvider } from "react-i18next";
import i18next from './components/i18n/i18n';
import CurrencyContext from './store/CurrencyContext';
import ErrorMessageProvider from './store/ErrorMessageProvider';
import ErrorMessageContext from './store/ErrorMessageContext';
import { isMobile } from 'react-device-detect';
import LazyThemeCss from './components/LazyThemeCss/LazyThemeCss';

const App = () => {
  
  // For Google Analytics
  useEffect(() => {
    ReactGA.initialize('G-RNM71PTFZ4');
  }, []);

  const appRef = useRef();
  const [appHeight, setAppHeight] = useState(0);
  const currencyCtx = useContext(CurrencyContext);
  const languageParentWindow = currencyCtx.languageParentWindow;
  const { errorMessages } = useContext(ErrorMessageContext);

  useEffect(() => {
    i18next.changeLanguage(languageParentWindow);
  }, [languageParentWindow]);

  const [nberOfOffers, setnberOfOffers] = useState([0]);
  const getNberOfOffers = (val) => {
    setnberOfOffers(val);
  };

  const [autocompleteKey, setAutocompleteKey] = useState('');
  const getAutocompleteKey = (key) => {
    setAutocompleteKey(key);
  };

  useEffect(() => {
    const iframeHeight = isMobile ? appRef.current.offsetHeight - 10 : appRef.current.offsetHeight;
    setAppHeight(iframeHeight);

    let communication = () => {
      let url = window.location !== window.parent.location ? document.referrer : document.location.href;
      window.parent.postMessage(appHeight, url);
    };
    
    if (appHeight > 200) communication();
  }, [nberOfOffers, appHeight]);

  return (
    <I18nextProvider i18n={i18next}>
      <ErrorMessageProvider>
        <CurrencyProvider>
          <OfferProvider>
            <LazyThemeCss>
              <div className="App" ref={appRef}>
                <ErrorMessage errorMessages={errorMessages} />
                <div className={classes.appContainer}>
                  <div className={classes.inputsContainer}>
                    <CountrySelector />
                    <DataSelector key={`${autocompleteKey}-data`} />
                    <DurationSelector id={`${autocompleteKey}-duration`} />
                  </div>
                  <Offers onSendData={getNberOfOffers} onResetKey={getAutocompleteKey} />
                </div>
              </div>
            </LazyThemeCss>
          </OfferProvider>
        </CurrencyProvider>
      </ErrorMessageProvider>
    </I18nextProvider>
  );
}

export default App;